/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const defaultNormalizeContextItem = ({ itemRef, typeId, snapshot, label, crn, id, ...rest }) => {
  if (!itemRef) {
    return null;
  }

  if (!snapshot || typeof snapshot !== 'object' || Array.isArray(snapshot)) {
    return null;
  }

  return {
    itemRef,
    typeId,
    snapshot,
    label: label ?? itemRef,
    crn,
    id,
    ...rest,
  };
};
